import type { PaginationQuery } from '../../../types/pagination';
import { appendPaginationQuery } from '../../../types/pagination';
import type { ApiClient } from '../client';
import type {
  ApiResponse,
  FinalizeAiQuestionsRequest,
  FinalizeAiQuestionsResponse,
  GenerateAiQuestionsRequest,
  GenerateAiQuestionsResponse,
  ListAiQuestionsResponse,
} from '../types';

export function bindAiQuestions(client: ApiClient) {
  return {
    async listAiQuestions(params?: PaginationQuery): Promise<ApiResponse<ListAiQuestionsResponse>> {
      const qs = new URLSearchParams();
      appendPaginationQuery(qs, params);
      const query = qs.toString();
      const path = query ? `/ai/questions?${query}` : '/ai/questions';
      return client.request<ListAiQuestionsResponse>(path);
    },

    async generateAiQuestions(
      body: GenerateAiQuestionsRequest
    ): Promise<ApiResponse<GenerateAiQuestionsResponse>> {
      return client.request<GenerateAiQuestionsResponse>('/ai/questions/generate', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async finalizeAiQuestions(
      body: FinalizeAiQuestionsRequest
    ): Promise<ApiResponse<FinalizeAiQuestionsResponse>> {
      return client.request<FinalizeAiQuestionsResponse>('/ai/questions/finalize', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },
  };
}
